/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceRetailer } from './SurfaceRetailer';
import {
    SurfaceRetailerFromJSON,
    SurfaceRetailerFromJSONTyped,
    SurfaceRetailerToJSON,
    SurfaceRetailerToJSONTyped,
} from './SurfaceRetailer';
import type { SurfaceProduct } from './SurfaceProduct';
import {
    SurfaceProductFromJSON,
    SurfaceProductFromJSONTyped,
    SurfaceProductToJSON,
    SurfaceProductToJSONTyped,
} from './SurfaceProduct';

/**
 * Products and retailers section configuration
 * @export
 * @interface SurfaceProductsConfig
 */
export interface SurfaceProductsConfig {
    /**
     * 
     * @type {string}
     * @memberof SurfaceProductsConfig
     */
    sectionTitle?: string;
    /**
     * 
     * @type {Array<SurfaceProduct>}
     * @memberof SurfaceProductsConfig
     */
    products?: Array<SurfaceProduct>;
    /**
     * 
     * @type {Array<SurfaceRetailer>}
     * @memberof SurfaceProductsConfig
     */
    retailers?: Array<SurfaceRetailer>;
    /**
     * 
     * @type {string}
     * @memberof SurfaceProductsConfig
     */
    backgroundImageId?: string;
}

/**
 * Check if a given object implements the SurfaceProductsConfig interface.
 */
export function instanceOfSurfaceProductsConfig(value: object): value is SurfaceProductsConfig {
    return true;
}

export function SurfaceProductsConfigFromJSON(json: any): SurfaceProductsConfig {
    return SurfaceProductsConfigFromJSONTyped(json, false);
}

export function SurfaceProductsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceProductsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'sectionTitle': json['sectionTitle'] == null ? undefined : json['sectionTitle'],
        'products': json['products'] == null ? undefined : ((json['products'] as Array<any>).map(SurfaceProductFromJSON)),
        'retailers': json['retailers'] == null ? undefined : ((json['retailers'] as Array<any>).map(SurfaceRetailerFromJSON)),
        'backgroundImageId': json['backgroundImageId'] == null ? undefined : json['backgroundImageId'],
    };
}

export function SurfaceProductsConfigToJSON(json: any): SurfaceProductsConfig {
    return SurfaceProductsConfigToJSONTyped(json, false);
}

export function SurfaceProductsConfigToJSONTyped(value?: SurfaceProductsConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sectionTitle': value['sectionTitle'],
        'products': value['products'] == null ? undefined : ((value['products'] as Array<any>).map(SurfaceProductToJSON)),
        'retailers': value['retailers'] == null ? undefined : ((value['retailers'] as Array<any>).map(SurfaceRetailerToJSON)),
        'backgroundImageId': value['backgroundImageId'],
    };
}

